import { render, staticRenderFns } from "./GSelector.vue?vue&type=template&id=8007bcc4&"
import script from "./GSelector.vue?vue&type=script&lang=ts&"
export * from "./GSelector.vue?vue&type=script&lang=ts&"
import style0 from "./GSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports